if (!customElements.get('blog-carousel')) {
  class BlogCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('[data-bc-swiper]');
      this.nextBtn = this.querySelector('[data-bc-next]');
      this.currentEl = this.querySelector('[data-bc-counter-current]');
      this.totalEl = this.querySelector('[data-bc-counter-total]');

      this.initSwiper();
    }

    disconnectedCallback() {
      clearTimeout(this.swiperRetry);
      if (this.swiperEl && this.swiperEl.swiper) this.swiperEl.swiper.destroy(true, true);
    }

    initSwiper() {
      if (!this.swiperEl || this.swiperEl.swiper) return;

      if (typeof Swiper === 'undefined') {
        this.swiperRetry = setTimeout(() => this.initSwiper(), 100);
        return;
      }

      const swiper = new Swiper(this.swiperEl, {
        slidesPerView: parseFloat(this.dataset.slidesMobile) || 1.2,
        spaceBetween: parseFloat(this.dataset.gapMobile) || 10,
        grabCursor: true,
        rewind: this.dataset.rewind === 'true',
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: parseFloat(this.dataset.slidesTablet) || 1.8,
            spaceBetween: parseFloat(this.dataset.gapDesktop) || 20,
          },
          1000: {
            slidesPerView: parseFloat(this.dataset.slidesDesktop) || 2.4,
            spaceBetween: parseFloat(this.dataset.gapDesktop) || 20,
          },
        },
      });

      ['slideChange', 'resize', 'breakpoint'].forEach((evt) => swiper.on(evt, () => this.syncNav(swiper)));
      this.syncNav(swiper);

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => swiper.slideNext());
      }
    }

    /* The counter is page-based: how many swipes' worth of cards there are at
       the current breakpoint, and which one is on screen. */
    syncNav(swiper) {
      const total = swiper.slides.length;
      const perView = Math.max(1, Math.floor(swiper.params.slidesPerView) || 1);
      const pages = Math.max(1, Math.ceil(total / perView));
      const page = swiper.isEnd ? pages : Math.min(pages, Math.floor(swiper.activeIndex / perView) + 1);

      if (this.currentEl) this.currentEl.textContent = page;
      if (this.totalEl) this.totalEl.textContent = pages;
      if (this.nextBtn) this.nextBtn.disabled = swiper.isEnd && !swiper.params.rewind;
    }
  }

  customElements.define('blog-carousel', BlogCarousel);
}
